import { Component, Injector, OnInit } from '@angular/core';

import { I18nService } from '@recruitee/i18n';
import { ConnectionPositionPair, IconName } from '@recruitee/user-interface';

import { WysiwygAction, WysiwygEmbeddableComponent } from '../adapter/wysiwyg-adapter.types';
import { WysiwygLink, WysiwygLinkType } from './wysiwyg-link.types';

export enum ActionType {
  LinkDelete = 'LinkDelete',
}

export type WysiwygLinkDeleteAction = WysiwygAction<ActionType.LinkDelete, WysiwygLink>;

export type WysiwygLinkAction = WysiwygLinkDeleteAction;

@Component({
  selector: 'rt-wysiwyg-link',
  templateUrl: './wysiwyg-link.component.html',
  styleUrls: ['./wysiwyg-link.component.less'],
})
export class WysiwygLinkComponent
  extends WysiwygEmbeddableComponent<WysiwygLink, WysiwygLinkAction>
  implements OnInit
{
  public dropdownOpened: boolean = false;

  public readonly icons: { [key in WysiwygLinkType]?: IconName } = {
    [WysiwygLinkType.Scheduler]: 'access-time',
    [WysiwygLinkType.GdprChange]: 'file-account',
    [WysiwygLinkType.GdprRemove]: 'account-alert',
    [WysiwygLinkType.Questionnaires]: 'list',
    [WysiwygLinkType.IntegrationsKununuApplicantFeedback]: 'list',
    [WysiwygLinkType.IntegrationsKununuEmployeeFeedback]: 'list',
  };

  public dropdownPositions: ConnectionPositionPair[] = [
    new ConnectionPositionPair(
      { originX: 'start', originY: 'bottom' },
      { overlayX: 'start', overlayY: 'top' },
    ),
    new ConnectionPositionPair(
      { originX: 'start', originY: 'top' },
      { overlayX: 'start', overlayY: 'bottom' },
    ),
  ];

  public texts: {
    dropdownTitle: string | undefined;
    linkName: string | undefined;
  } = {
    dropdownTitle: undefined,
    linkName: undefined,
  };

  constructor(protected injector: Injector, private i18n: I18nService) {
    super(injector);
  }

  public remove(link: WysiwygLink): void {
    this.emit(new WysiwygAction(ActionType.LinkDelete, link));
  }

  // eslint-disable-next-line max-lines-per-function
  protected onStateChange(nextState: WysiwygLink, prevState: WysiwygLink): void {
    // eslint-disable-next-line default-case
    switch (nextState.type) {
      case WysiwygLinkType.Scheduler:
        this.texts = {
          dropdownTitle: this.i18n.translate('app.wysiwyg.link.scheduler_dropdown_title'),
          linkName: this.i18n.translate('app.wysiwyg.link.scheduler_link_name'),
        };
        break;

      case WysiwygLinkType.Questionnaires:
        this.texts = {
          dropdownTitle: this.i18n.translate('app.wysiwyg.link.questionnaire_dropdown_title'),
          linkName: this.i18n.translate('app.wysiwyg.link.questionnaire_link_name'),
        };
        break;

      case WysiwygLinkType.IntegrationsKununuApplicantFeedback:
        this.texts = {
          dropdownTitle: this.i18n.translate(
            'app.wysiwyg.link.integrations_kununu_applicant_feedback_dropdown_title',
          ),
          linkName: this.i18n.translate(
            'app.wysiwyg.link.integrations_kununu_applicant_feedback_link_name',
          ),
        };
        break;

      case WysiwygLinkType.IntegrationsKununuEmployeeFeedback:
        this.texts = {
          dropdownTitle: this.i18n.translate(
            'app.wysiwyg.link.integrations_kununu_employee_feedback_dropdown_title',
          ),
          linkName: this.i18n.translate(
            'app.wysiwyg.link.integrations_kununu_employee_feedback_link_name',
          ),
        };
        break;
    }

    super.onStateChange(nextState, prevState);
  }
}
